export { default as InAppBrowserNavigator, cordovaOidcSettings } from './InAppBrowserNavigator';

export const isInAppBrowserAvailable = () => !!window.cordova?.InAppBrowser;
